/**
 * Gift Card Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Gift Card template.
 */

// TODO: check if the QR code feature works
// it's being included in the script-tags.liquid file but not sure if that file is stable

const selectorsGiftCards = {
  qrCodeCanvas: '[data-gift-card-qr]',
  printButton: '[data-gift-card-print]',
  giftCardCode: '[data-gift-card-digits]',
};

// This is the QR code that allows customers to use at a POS
document.querySelectorAll(selectorsGiftCards.qrCodeCanvas).forEach((element) => {
  QRCode.toCanvas(element, element.dataset.identifier);
});

// Bug: all three blocks used to pass the whole selectorsGiftCards object to
// querySelectorAll instead of a specific key. A plain object coerces to the
// string "[object Object]", which isn't a valid CSS selector — the first
// call above threw a SyntaxError and halted the rest of the script, so the
// Print button's click listener below never actually got attached (reported
// by Michelle: "The print link isn't doing anything for me").
document.querySelectorAll(selectorsGiftCards.printButton).forEach((element) => {
  element.addEventListener('click', () => {
    window.print();
  });
});

// Auto-select gift card code on click, based on ID passed to the function
document.querySelectorAll(selectorsGiftCards.giftCardCode).forEach((element) => {
  element.addEventListener('click', (evt) => {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(evt.target);
    selection.removeAllRanges();
    selection.addRange(range);
  });
});
